"use strict";
import date_format from "date-and-time";
import i18n from "@/lang";
export class Timestamp {
  constructor(timestamp) {
    this._timestamp = 0;
    this._timestamp = timestamp;
  }
  date(formatString, utc = false) {
    return date_format.format(new Date(this._timestamp), formatString, utc);
  }
  localization(mode) {
    return i18n.d(new Date(this._timestamp), mode);
  }
  check() {
    const _time = String(this._timestamp);
    if (_time.length > 10) {
      return this._timestamp;
    }
    this._timestamp = this._timestamp * 1e3;
    return this._timestamp;
  }
  dateTime() {
    const date = new Date();
    date.setTime(this._timestamp);
    return date.toLocaleString();
  }
  last() {
    return {
      day: () => {
        return Math.ceil(this._timestamp / 86400);
      }
    };
  }
  dateformatterDay() {
    return date_format.format(new Date(this.check()), "YYYY-MM-DD");
  }
  dateformat() {
    return date_format.format(new Date(this.check()), "YYYY/MM/DD HH:mm:ss");
  }
  dateformatMin() {
    return date_format.format(new Date(this.check()), "YYYY/MM/DD HH:mm");
  }
  dateformatter() {
    return date_format.format(new Date(this.check()), "YYYY-MM-DD HH:mm:ss");
  }
  dateformatDay() {
    return date_format.format(new Date(this.check()), "YYYY/MM/DD");
  }
  format_login_time() {
    if (!this._timestamp) {
      return "-";
    }
    this.check();
    let _time = Date.now() - this._timestamp;
    if (_time < 6e4) {
      return i18n.t("timefomatter.seconds_ago");
    }
    if (_time < 36e5) {
      _time = Math.floor(_time / (1e3 * 60));
      return i18n.t("timefomatter.minites_ago", { time: _time });
    }
    if (_time < 864e5) {
      _time = Math.floor(_time / (1e3 * 60 * 60));
      return i18n.t("timefomatter.hours_ago", { time: _time });
    }
    if (i18n.locale === "zh-CN") {
      return date_format.format(new Date(this._timestamp), "YYYY-M-DD HH:mm");
    }
    if (i18n.locale !== "zh-CN") {
      return date_format.format(new Date(this._timestamp), "DD.MM.YYYY HH:mm");
    }
    return date_format.format(new Date(this._timestamp), "MMM DD,YYYY");
  }
}
